import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { login } from "../../actions/authActions";
import Login from "../../components/Login";

export class Auth extends Component {
    login = (username, password) => {
        this.props.dispatch(login(username, password));
    };

    render() {
        return (
            <div>
                {
                    this.props.isAuthenticated ? (
                        <Redirect to="/" />
                    ) :
                    (
                        <Login
                            onLoginClick={this.login}
                            errorMessage={this.props.errorMessage}
                            isFetching={this.props.isFetching}
                        />
                    )
                }
            </div>
        )
    }
}

Auth.propTypes = {
    dispatch: PropTypes.func.isRequired,
    isAuthenticated: PropTypes.bool.isRequired,
    errorMessage: PropTypes.string.isRequired,
    isFetching: PropTypes.bool.isRequired,
    history: PropTypes.shape({
        push: PropTypes.func.isRequired,
    }).isRequired,
};

const mapStateToProps = (state) => {
    const { auth } = state;
    const {
        isAuthenticated,
        errorMessage,
        isFetching
    } = auth;
    return {
        isAuthenticated,
        errorMessage,
        isFetching
    }
};

export default connect(mapStateToProps)(Auth);
